import Product from "./product-detail";
import { useState, useEffect } from "react";
import { useUser, useUI, useProduct } from "../contexts";
import { useRouter } from "next/router";
import ChatModal from "./chat-modal";
import { Footer } from "./footer";
import { SellwildMainTv } from "./embed-tags/sellwild-tv";

const ProductModal = () => {
	const router = useRouter();
	const { setProductOpen } = useUI();
	const { productDetail, removeProduct } = useProduct();
	const { profile } = useUser();
	const [showTv, setShowTv] = useState(false)
	// SEEDED FROM THE ROUTER, NOT EMPTY.
	//
	// This started at '' and was filled in an effect, so on the first client
	// render after hydration `isProductPage` was false on a product page — and
	// the effect below answers that by calling `removeProduct()`. It wiped the
	// server-rendered product out of the context, the page fell back to
	// `<ProductSkeleton/>`, and the next tick put it back. Every product page
	// load flashed its own skeleton for ~50ms and moved everything under the
	// banner ad with it: measured on staging, one layout shift of 0.636, which
	// is the whole of that page's CLS.
	//
	// `router.asPath` is the same string on the server and on the client, so
	// seeding from it costs no hydration mismatch. The effect still tracks
	// `window.location.pathname` afterwards, because the flip buttons move the
	// URL by history API without telling the Next router.
	const [currentPath, setCurrentPath] = useState(router.asPath);

	// Force re-render on route changes
	useEffect(() => {
		const handleRouteChange = () => {
			setCurrentPath(window.location.pathname);
		};

		router.events.on('routeChangeComplete', handleRouteChange);
		return () => {
			router.events.off('routeChangeComplete', handleRouteChange);
		};
	}, [router.events]);

	// Check if we're on a product page
	const isProductPage = currentPath.includes('/product/');

	useEffect(() => {
		const exists = document.querySelector('sellwild-tv')
		if (!exists) {
			// eslint-disable-next-line react-hooks/set-state-in-effect -- reads external DOM state (presence of an existing <sellwild-tv> element) on mount; not derivable during render (DOM query is SSR-unsafe)
			setShowTv(true)
		}
	}, [])

	// Sync productOpen state. Leaving a product page clears the product.
	// `currentPath` is always a real path now (seeded from router.asPath, then
	// window.location.pathname); it used to start empty, read as "not on a
	// product page", and throw away the product we were showing.
	useEffect(() => {
		setProductOpen(isProductPage);
		if (!isProductPage) {
			removeProduct();
		}
	}, [currentPath, isProductPage, setProductOpen, removeProduct]);

	const product = productDetail
	const isOwnListing = profile && product?.user && product?.user?.id == profile?.id;

	// Don't render at all if not on a product page
	if (!isProductPage) {
		return null;
	}

	return (
		<div className="product-modal-bg" data-testid="product-modal-bg">
			<div className="product-modal same-color" data-testid="product-modal">
				<Product />
				{showTv && productDetail && <SellwildMainTv floatBehavior="before" listingId={productDetail.id} />}
				{/*<GoogleAdsenseTag />*/}
				<ChatModal isOwnListing={isOwnListing} id={product?.id} companion={product?.user} />
			</div>
			<Footer />
		</div>
	);
};
export default ProductModal;
